import { LuShoppingBag, LuUndo2, LuReceipt } from "react-icons/lu";
import { PurchaseOrderData, PurchaseOrderCreate, PurchaseOrderDetail, PurchaseOrderPrint } from "@/pages/purchase-order";
import { PurchaseOrderReturnData, PurchaseOrderReturnCreate, PurchaseOrderReturnDetail, PurchaseOrderReturnPrint } from "@/pages/purchase-order-return";
import { PurchasePaymentData, PurchasePaymentCreate, PurchasePaymentDetail, PurchasePaymentPrint } from "@/pages/purchase-payment";

export const purchasingPrintRoutes = [
    {
        path: "/purchase-order/:id/print",
        component: <PurchaseOrderPrint />,
        permission: "purchase-order.view",
    },
    {
        path: "/purchasing/return/:id/print",
        component: <PurchaseOrderReturnPrint />,
        permission: "purchase-order-return.view",
    },
    {
        path: "/purchase-payment/:id/print",
        component: <PurchasePaymentPrint />,
        permission: "purchase-payment.view",
    },
];

export const purchasingRoutes = {
    title: "PEMBELIAN",
    type: "section",
    items: [
        {
            path: "/purchase-order",
            title: "Pembelian",
            icon: <LuShoppingBag />,
            permission: "purchase-order.view",
            children: [
                {
                    path: "/purchase-order",
                    title: "Daftar Purchase Order",
                    component: <PurchaseOrderData />,
                },
                {
                    path: "/purchase-order/create",
                    title: "Tambah Purchase Order",
                    component: <PurchaseOrderCreate />,
                    permission: "purchase-order.create",
                    type: "hidden",
                },
                {
                    path: "/purchase-order/:id/edit",
                    title: "Edit Purchase Order",
                    component: <PurchaseOrderCreate />,
                    permission: "purchase-order.edit",
                    type: "hidden",
                },
                {
                    path: "/purchase-order/:id/detail",
                    title: "Detail Purchase Order",
                    component: <PurchaseOrderDetail />,
                    permission: "purchase-order.view",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/purchasing/return",
            title: "Retur Pembelian",
            icon: <LuUndo2 />,
            permission: "purchase-order-return.view",
            children: [
                {
                    path: "/purchasing/return",
                    title: "Daftar Retur Pembelian",
                    component: <PurchaseOrderReturnData />,
                },
                {
                    path: "/purchasing/return/create",
                    title: "Buat Retur Pembelian",
                    component: <PurchaseOrderReturnCreate />,
                    permission: "purchase-order-return.create",
                    type: "hidden",
                },
                {
                    path: "/purchasing/return/:id/edit",
                    title: "Edit Retur Pembelian",
                    component: <PurchaseOrderReturnCreate />,
                    permission: "purchase-order-return.edit",
                    type: "hidden",
                },
                {
                    path: "/purchasing/return/:id/detail",
                    title: "Detail Retur Pembelian",
                    component: <PurchaseOrderReturnDetail />,
                    permission: "purchase-order-return.view",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/purchase-payment",
            title: "Pembayaran Pembelian",
            icon: <LuReceipt />,
            permission: "purchase-payment.view",
            children: [
                {
                    path: "/purchase-payment",
                    title: "Daftar Pembayaran",
                    component: <PurchasePaymentData />,
                },
                {
                    path: "/purchase-payment/create",
                    title: "Buat Pembayaran Pembelian",
                    component: <PurchasePaymentCreate />,
                    permission: "purchase-payment.create",
                    type: "hidden",
                },
                {
                    path: "/purchase-payment/:id/edit",
                    title: "Edit Pembayaran Pembelian",
                    component: <PurchasePaymentCreate />,
                    permission: "purchase-payment.edit",
                    type: "hidden",
                },
                {
                    path: "/purchase-payment/:id/detail",
                    title: "Detail Pembayaran Pembelian",
                    component: <PurchasePaymentDetail />,
                    permission: "purchase-payment.view",
                    type: "hidden",
                },
            ],
        },
    ],
};
